import { apiClient } from '../../axios';
import {
  GetEarnBenefitResponse,
  GetEarnHistoryParams,
  GetEarnHistoryResponse,
  GetEarnNudgesResponse,
  GetEarnStatisticsResponse,
  GetEarnSummaryResponse,
  GetMintConfirmResponse,
  GetMintExchangeRateParams,
  GetMintExchangeRateResponse,
  GetMintOverviewResponse,
  GetMintPendingResponse,
  PostMintPreviewParams,
  PostMintPreviewResponse,
} from './types';

export const getEarnHistoryApi = (params: GetEarnHistoryParams) =>
  apiClient.get<GetEarnHistoryResponse>('/v1/earn/history', { params });
export const getEarnBenefitApi = () => apiClient.get<GetEarnBenefitResponse>('/v1/earn/benefit');
export const getEarnSummaryApi = () => apiClient.get<GetEarnSummaryResponse>('/v1/earn/summary');
export const getEarnStatisticsApi = () => apiClient.get<GetEarnStatisticsResponse>('/v1/earn/statistics');

export const getMintOverviewApi = (params: { currency: string }) =>
  apiClient.get<GetMintOverviewResponse>('/v1/mint/overview', { params });

export const getMintExchangeRateApi = (params: GetMintExchangeRateParams) =>
  apiClient.get<GetMintExchangeRateResponse>('/v1/mint/exchange-rate', { params });

export const postMintPreviewApi = (params: PostMintPreviewParams) =>
  apiClient.post<PostMintPreviewResponse>('/v1/mint/preview', params);

export const getMintConfirmApi = (params: { id: number }) =>
  apiClient.post<GetMintConfirmResponse>('/v1/mint/confirm', params);

export const getMintPendingApi = () => apiClient.get<GetMintPendingResponse>('/v1/mint/pending');

export const getEarnNudgesApi = () => apiClient.get<GetEarnNudgesResponse>('/v1/earn/nudges');
